/* eslint-disable react-hooks/exhaustive-deps */
/**
 * B010060 受注ワーク入力
 */
import { Box } from "@mui/material";
import {
  msgState,
  SCancelButton,
  SCodeSelect,
  SConfirmDialogAction,
  SDateField,
  SEntryTab,
  SFrame,
  SInfoButton,
  SLabel,
  SNormalButton,
  SNumberField,
  STable,
  SText,
  STextField,
} from "components";
import {
  ChohaKbn,
  getSCode,
  HasokbnCd,
  HasosakiCd,
  JuchuKbn,
  NetsukeKbn,
  PpgakeKbn,
  SCode,
  JuchuUchiwakeKbn,
  ZeiKbn,
  JuchuSeisanhinKbn,
  HyoziKazeiKbn,
} from "messages/codes";
import {
  B010010Nonyu,
  B000111Biko,
  B000111Meisaibiko,
  B000111LineNm,
  B000140Shain,
  B000140AssistantNm,
  B000111DenpyoshubetsuNmAndTenpudenpyo,
  B000111TenpudenpyoNmByDenpyoshubetsu,
  B000111UnsogaishaNm,
  B010010HandleChangeShohinCd,
  B010010HandleChangeJanCd,
  B010010Kanosu,
  B010010Shohin,
  B010010WhTanka,
  B010060Update,
  B000190SokoNmSokoshubetsuKbn,
  B010010Tokui,
  B010010ZeiRitsu,
  B010070GetResponse,
  catchRestError,
  B010010TankaList,
  B010010ShohinZaiko,
  B010010Tanka,
} from "clients/rest";
import { labels } from "messages/labels";
import {
  B000111,
  B000140,
  B000150,
  B000151,
  B000190,
  B000200,
  B000220,
  B010011,
  B010012,
  B010012Props,
} from "pages";
import { createRef, useEffect, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { useRecoilValue, useSetRecoilState } from "recoil";
import {
  digit,
  getHitsuyosu,
  getJodaitanka,
  getJuchuKin,
  getJuchutanka,
  getKakeritsu,
  getUchizeiJuchutanka,
} from "services/CalcService";
import { focusState, useFocus } from "states";
import Big, { RoundingMode } from "big.js";
import { useLocation, useNavigate } from "react-router-dom";
import {
  editKbn,
  juchuSeisanhinKbn,
  meishoKbn,
  setshohinKbn,
  shohinShokuchiKbn,
  shohinshubetsuKbn,
  shokuchiKbn,
  sokoshubetsuKbn,
  tankaKbn,
  tenyuryokujodaiKbn,
  tenyuryokujuchuKbn,
  zeiKbn,
  zeimarumeKbn,
} from "services/codes";
import { Column } from "@material-table/core";
import { getClientError, getClientMessage } from "messages";
import { date, validDate } from "services";

//画面遷移
//TO DO 在庫数照会のダイアログ処理 L1414

export type B010060InputData = {
  editKbn: string;
  juchuWork: B010070GetResponse;
};

// 呼び出し時のプロパティ
type Props = Partial<{}>;

// コンポーネントで設定されるフィールドの型を定義する
// ヘッダ部
type Fields = Partial<{
  editKbn: string;
  juchuKbn: SCode;
  juchudenpyoNo: string;
  juchuworkdenpyoNo: string;
  juchuYmd: string | null;
  nohinyoteiYmd: string | null;
  tokuiShokuchiKbn: string;
  tokuiCd: string;
  tokuishitenCd: string;
  tokuiNm: string;
  tankaKakeritsu: string;
  zeimarumeKbn: number;
  kinmarumeKbn: number;
  tokuiPostCd: string;
  tokuiAddress1: string;
  tokuiAddress2: string;
  tokuiTelNo: string;
  tokuiFaxNo: string;
  nonyuShokuchiKbn: number;
  nonyuCd: string;
  nonyushitenCd: string;
  nonyuNm: string;
  nonyuPostCd: string;
  nonyuAddress1: string;
  nonyuAddress2: string;
  nonyuTelNo: string;
  nonyuFaxNo: string;
  ediMemo: string;
  shainCd: string;
  shainNm: string;
  eigyoCd: string;
  seisakuYmd: string | null;
  shukayoteiYmd: string | null;
  jisanYmd: string | null;
  denpyoYmd: string | null;
  shimeD: string;
  chohaKbn: SCode;
  hasosakiCd: SCode;
  hasokbnCd: SCode;
  zeiKbnView: SCode;
  zeiKbn: string;
  assistantCd: string;
  assistantNm: string;
  denpyoshubetsuCd: string;
  denpyoshubetsuNm: string;
  tenpudenpyoCd: string;
  tenpudenpyoNm: string;
  bunrui: string;
  unsogaishaCd: string;
  unsogaishaNm: string;
  bumonCd: string;
  bumonNm: string;
  ppgakeKbn: SCode;
  netsukeKbn: SCode;
  denpyoKbn: string;
  chumonNo: string;
  ritsu: string;
  hinbetsuNo: string;
  tantosha: string;
  bikoCd: string;
  biko: string;
  bikoCdBefore: string;
  nohinsaki: string;
  lineCd: string;
  lineNm: string;
  uribaNm: string;
  naisen: string;
  juchuKinGokei: string;
  zeiGokei: string;
  denpyoGokei: string;
  ediKbn: string;
  ediJuchuNo: string;
  version: string;
  zeiRitsu: string;
  jodaihyojiKbn: string;
  tankamarumeKbn: string;
  tankahasuichi: string;
  juchuHaneiKbn: string;
}>;

//明細入力部
type MeiFields = MeiData &
  Partial<{
    meiTab: boolean;
  }>;

// 明細データ
type MeiData = Partial<{
  juchugyoNo: number;
  uchiwakeKbn: SCode;
  juchuSeisanhinKbn: SCode;
  shohinCd: string;
  janCd: string;
  shohinNm: string;
  aiteCd: string;
  sokoCd: string;
  sokoNm: string;
  vol: string;
  sotosunW: string;
  sotosunH: string;
  uchisunW: string;
  uchisunH: string;
  juchusu: string;
  kanosu: string;
  tenyuryokujodaiKbn: number;
  tenyuryokujuchuKbn: number;
  basejodaitanka: string;
  basejuchutanka: string;
  jodaitanka: string;
  juchutanka: string;
  kakeritsu: string;
  juchuKin: string;
  meisaibikoCd: string;
  meisaibikoCdBefore: string;
  meisaibiko: string;
  kazeiKbnView: string;
  kazeiKbn: number;
  setshohinKbn: number;
  edishohinNm: string;
  crtDate: string;
  crtshainCd: string;
  shohinshubetsuKbn: number;
  tankaKbn: number;
  shokuchiKbn: number;
  whtankaCd: string;
  sokoshubetsuKbn: number;
  koseiData: KoseiData[];
}>;

// セット構成品データ定義
type KoseiData = Partial<{
  juchugyoNo: number;
  juchukoseigyoNo: number;
  shohinCd: string;
  janCd: string;
  shohinNm: string;
  aiteCd: string;
  sokoCd: string;
  sokoNm: string;
  vol: string;
  sotosunW: string;
  sotosunH: string;
  uchisunW: string;
  uchisunH: string;
  hitsuyosu: string;
  koseisu: string;
  kanosu: string;
  tenyuryokujodaiKbn: number;
  tenyuryokujuchuKbn: number;
  basejodaitanka: string;
  basejuchutanka: string;
  jodaitanka: string;
  juchutanka: string;
  kakeritsu: string;
  juchuKin: string;
  meisaikoseiBikoCd: string;
  meisaikoseiBiko: string;
  kazeiKbn: number;
  shohinshubetsuKbn: number;
  tankaKbn: number;
  shokuchiKbn: number;
  whtankaCd: string;
  sokoshubetsuKbn: number;
  setshohinKbn: number;
  crtDate: string;
  crtshainCd: string;
}>;

// 明細テーブルデータ定義
type Data = Partial<{
  juchugyoNo: number;
  uchiwakeKbnView: string;
  uchiwakeKbn: string;
  juchuSeisanhinKbnView: string;
  juchuSeisanhinKbn: string;
  shohinCd: string;
  janCd: string;
  shohinNm: string;
  edishohinNm: string;
  aiteCd: string;
  sokoCd: string;
  sokoNm: string;
  vol: string;
  sotosunView: string;
  uchisunView: string;
  sotosunW: string;
  sotosunH: string;
  uchisunW: string;
  uchisunH: string;
  juchusu: string;
  kanosu: string;
  tenyuryokujodaiKbn: number;
  tenyuryokujuchuKbn: number;
  basejodaitanka: string;
  basejuchutanka: string;
  jodaitanka: string;
  juchutanka: string;
  kakeritsu: string;
  juchuKin: string;
  meisaibikoCd: string;
  meisaibiko: string;
  kazeiKbnView: string;
  kazeiKbn: number;
  setshohinKbn: number;
  crtDate: string;
  crtshainCd: string;
  shohinshubetsuKbn: number;
  tankaKbn: number;
  shokuchiKbn: number;
  whtankaCd: string;
  sokoshubetsuKbn: number;
  koseiData: KoseiData[];
}>;

// フィールドの初期値を設定する。
// ヘッダ部
const defaultFields: Fields = {
  editKbn: editKbn.register,
  juchuKbn: undefined,
  juchudenpyoNo: "",
  juchuworkdenpyoNo: "",
  juchuYmd: null,
  nohinyoteiYmd: null,
  tokuiShokuchiKbn: "",
  tokuiCd: "",
  tokuishitenCd: "",
  tokuiNm: "",
  tankaKakeritsu: "",
  zeimarumeKbn: undefined,
  kinmarumeKbn: undefined,
  tokuiPostCd: "",
  tokuiAddress1: "",
  tokuiAddress2: "",
  tokuiTelNo: "",
  tokuiFaxNo: "",
  nonyuShokuchiKbn: undefined,
  nonyuCd: "",
  nonyushitenCd: "",
  nonyuNm: "",
  nonyuPostCd: "",
  nonyuAddress1: "",
  nonyuAddress2: "",
  nonyuTelNo: "",
  nonyuFaxNo: "",
  ediMemo: "",
  shainCd: "",
  shainNm: "",
  eigyoCd: "",
  seisakuYmd: null,
  shukayoteiYmd: null,
  jisanYmd: null,
  denpyoYmd: null,
  shimeD: "",
  chohaKbn: undefined,
  hasosakiCd: null,
  hasokbnCd: null,
  zeiKbn: undefined,
  assistantCd: "",
  assistantNm: "",
  denpyoshubetsuCd: "",
  denpyoshubetsuNm: "",
  tenpudenpyoCd: "",
  tenpudenpyoNm: "",
  bunrui: "",
  unsogaishaCd: "",
  unsogaishaNm: "",
  bumonCd: "",
  bumonNm: "",
  ppgakeKbn: undefined,
  netsukeKbn: undefined,
  denpyoKbn: "",
  chumonNo: "",
  ritsu: "",
  hinbetsuNo: "",
  tantosha: "",
  bikoCd: "",
  biko: "",
  bikoCdBefore: "",
  nohinsaki: "",
  lineCd: "",
  lineNm: "",
  uribaNm: "",
  naisen: "",
  juchuKinGokei: "",
  zeiGokei: "",
  denpyoGokei: "",
  ediKbn: "",
  ediJuchuNo: "",
  version: "",
  zeiRitsu: "",
  jodaihyojiKbn: "",
  tankamarumeKbn: "",
  tankahasuichi: "",
  juchuHaneiKbn: "",
};

// 明細フィールド初期値
const defaultMeiFields: MeiFields = {
  meiTab: true,
  juchugyoNo: undefined,
  uchiwakeKbn: getSCode(JuchuUchiwakeKbn, "0"),
  juchuSeisanhinKbn: getSCode(JuchuSeisanhinKbn, juchuSeisanhinKbn.nashi),
  shohinCd: "",
  janCd: "",
  shohinNm: "",
  aiteCd: "",
  sokoCd: "",
  sokoNm: "",
  vol: "",
  sotosunW: "",
  sotosunH: "",
  uchisunW: "",
  uchisunH: "",
  juchusu: "",
  kanosu: "",
  tenyuryokujodaiKbn: undefined,
  tenyuryokujuchuKbn: undefined,
  basejodaitanka: undefined,
  basejuchutanka: undefined,
  jodaitanka: "",
  juchutanka: "",
  kakeritsu: "",
  juchuKin: "",
  meisaibikoCd: "",
  meisaibikoCdBefore: "",
  meisaibiko: "",
  kazeiKbnView: "",
  kazeiKbn: undefined,
  setshohinKbn: undefined,
  edishohinNm: "",
  crtDate: "",
  crtshainCd: "",
  shohinshubetsuKbn: undefined,
  tankaKbn: undefined,
  shokuchiKbn: undefined,
  whtankaCd: "",
  sokoshubetsuKbn: undefined,
  koseiData: [],
};

// テーブル設定
const columns: Column<Data>[] = [
  { field: "juchugyoNo", title: "行　", width: "3rem", align: "right" },
  { field: "uchiwakeKbnView", title: "区分", width: "3.5rem" },
  { field: "uchiwakeKbn", title: "内訳区分", hidden: true },
  { field: "juchuSeisanhinKbnView", title: "受注生産品", width: "4.5rem" },
  {
    field: "juchuSeisanhinKbn",
    title: "受注生産品",
    hidden: true,
  },
  { field: "shohinCd", title: "商品コード", width: "7rem" },
  { field: "aiteCd", title: "相手コード", width: "5rem" },
  { field: "janCd", hidden: true },
  { field: "shohinNm", title: "商品名", width: "10rem" },
  { field: "edishohinNm", title: "EDI商品名", width: "7rem" },
  { field: "vol", title: "VOL", width: "3rem" },
  {
    field: "sotosunView",
    title: "WH(外)",
    width: "6rem",
    render: (data) => {
      if (data.sotosunW && Number(data.sotosunW) > 0) {
        return data.sotosunW + " x " + data.sotosunH;
      }
    },
  },
  {
    field: "uchisunView",
    title: "WH(内)",
    width: "6em",
    render: (data) => {
      if (data.uchisunW && Number(data.uchisunW) > 0) {
        return data.uchisunW + " x " + data.uchisunH;
      }
    },
  },
  { field: "sotosunH", title: "外高さ", hidden: true },
  { field: "sotosunW", title: "外幅", hidden: true },
  { field: "uchisunW", title: "内幅", hidden: true },
  { field: "uchisunH", title: "内高さ", hidden: true },
  {
    field: "juchusu",
    title: "受注数",
    width: "3rem",
    align: "right",
    render: (data) => digit(data.juchusu),
  },
  {
    field: "kanosu",
    title: "可能数",
    width: "3rem",
    align: "right",
    render: (data) => digit(data.kanosu),
  },
  { field: "tenyuryokujodaiKbn", hidden: true },
  { field: "tenyuryokujuchuKbn", hidden: true },
  { field: "basejodaitanka", hidden: true },
  { field: "basejuchutanka", hidden: true },
  {
    field: "jodaitanka",
    title: "上代",
    width: "4rem",
    align: "right",
    render: (data) => {
      let backgroundColor = "inherit";
      if (data.tenyuryokujodaiKbn === tenyuryokujodaiKbn.exists) {
        backgroundColor = "#FFFF00";
      }
      return <Box sx={{ backgroundColor }}>{digit(data.jodaitanka)}</Box>;
    },
  },
  {
    field: "juchutanka",
    title: "下代	",
    width: "4rem",
    align: "right",
    render: (data) => {
      let backgroundColor = "inherit";
      if (data.tenyuryokujuchuKbn === tenyuryokujuchuKbn.exists) {
        backgroundColor = "#FFFF00";
      }
      return <Box sx={{ backgroundColor }}>{digit(data.juchutanka)}</Box>;
    },
  },
  { field: "kakeritsu", title: "掛率", width: "3rem", align: "right" },
  {
    field: "juchuKin",
    title: "受注金額	",
    width: "5rem",
    align: "right",
    render: (data) => digit(data.juchuKin),
  },
  { field: "meisaibikoCd", title: "明細備考コード", hidden: true },
  { field: "meisaibiko", title: "明細備考", width: "20rem" },
  { field: "sokoCd", title: "倉庫コード", width: "5rem" },
  { field: "sokoNm", title: "倉庫名", width: "10rem" },
  {
    field: "kazeiKbnView",
    title: "税",
    width: "4rem",
    render: (data) =>
      getSCode(HyoziKazeiKbn, data.kazeiKbn?.toString() ?? "")?.label,
  },
  { field: "kazeiKbn", title: "課税区分", width: "4rem", hidden: true },
  { field: "setshohinKbn", title: "セット商品区分", hidden: true },
  { field: "crtDate", hidden: true },
  { field: "crtshainCd", hidden: true },
  { field: "shohinshubetsuKbn", title: "商品種別区分", hidden: true },
  { field: "tankaKbn", title: "単価区分", hidden: true },
  { field: "shokuchiKbn", title: "諸口区分", hidden: true },
  { field: "whtankaCd", title: "WH 単価コード", hidden: true },
  { field: "sokoshubetsuKbn", title: "倉庫種別区分", hidden: true },
  { field: "koseiData", title: "セット構成品データ", hidden: true },
];

// 固定値
const juchusuMin = 0;
const KakerituRangeMin = 0;
const KakerituRangeMax = 999;
const juchuKinMaxLength = 9;
const jodaitankaMaxLength = 9;
const juchutankaMaxLength = 9;
const whMin = 0;

const focusId = "B010060";

const torihikishuryoYmd = date();

// B010160 受注ワーク入力
export const B010060 = (props: Props) => {
  useFocus(focusId);
  return <Page {...props} />;
};

const Page = (props: Props) => {
  // 初期設定
  // テーブル管理
  const tableRef = createRef();
  const [rows, setRows] = useState<Data[]>([]);
  const [rowCount, setRowCount] = useState(0);
  // テーブル行で選択されたデータ
  const [rowData, setRowData] = useState<Partial<Data>>();
  // フォーム関数
  const methods = useForm<Fields>({
    mode: "onBlur",
    defaultValues: defaultFields,
  });
  const meiMethods = useForm<MeiFields>({
    mode: "onBlur",
    defaultValues: defaultMeiFields,
  });

  // フォーカス関数
  const { focus, register } = useRecoilValue(focusState(focusId));
  // 遷移元データ取得用
  const navigate = useNavigate();
  const location = useLocation();
  const inputData = location.state as B010060InputData;
  // エラー表示
  const setMsg = useSetRecoilState(msgState);
  // 更新ボタンクリック時に出す確認ダイアログオープン用
  const [openUpdateConfirm, setOpenUpdateConfirm] = useState(false);

  // 活性設定
  // 参照モードかどうか
  const isReference = methods.watch("editKbn") === editKbn.reference;
  // 得意先.諸口が「1：諸口」かどうか
  const isNonyuShokuchi =
    methods.watch("nonyuShokuchiKbn") === shokuchiKbn.shokuchi;
  // 添付伝票の入力可否(伝票種別が未入力時、入力不可)
  const isTenpudenpyoCdDisabled = methods.watch("denpyoshubetsuCd") === "";
  // ベース上代単価、上代単価が一致するかどうか(手入力上代区分)
  const isTenyuryokujodaiKbn =
    Number(meiMethods.watch("basejodaitanka")) ===
    Number(meiMethods.watch("jodaitanka"));
  // ベース下代単価、下代単価が一致するかどうか(手入力受注区分)
  const isTenyuryokujuchuKbn =
    Number(meiMethods.watch("basejuchutanka")) ===
    Number(meiMethods.watch("juchutanka"));
  // 明細入力部への入力可否(有効な得意先が入力済(諸口区分が取得済)、かつ消費税率が取得済の場合、入力可能)
  const isMeiDisabled =
    methods.watch("tokuiShokuchiKbn") === "" ||
    methods.watch("zeiRitsu") === "";
  // 商品.商品種別区分が「4:受注生産品」かどうか
  const isMeiJuchuSeisanhin =
    meiMethods.watch("shohinshubetsuKbn") === shohinshubetsuKbn.madeToOrder;
  // 商品.諸口区分が「1:諸口」かどうか
  const isShohinShokuchiKbn =
    meiMethods.watch("shokuchiKbn") === shohinShokuchiKbn.shokuchi;
  // 商品.セット商品区分が「1:セット品」かどうか
  const isSetshohinKbn = meiMethods.watch("setshohinKbn") === setshohinKbn.set;
  const isKoseiDisabled = isMeiDisabled || !isSetshohinKbn;
  // 明細入力部の金額の入力可否(受注数が入力済、かつ下代が入力済の場合、入力不可)
  const isKingakuDisabled =
    meiMethods.watch("juchusu") !== "" && meiMethods.watch("juchutanka") !== "";

  // 初期表示(編集・参照時の設定)
  useEffect(() => {
    if (inputData === null) {
      return;
    }
    // 編集区分の設定
    methods.setValue("editKbn", inputData.editKbn);

    // 入力プロパティの反映
    const juchuWork = inputData.juchuWork;
    if (typeof juchuWork === "undefined") return;
    // 受注データ設定
    methods.setValue("juchuKbn", getSCode(JuchuKbn, "0"));
    methods.setValue("juchuworkdenpyoNo", juchuWork.juchuworkdenpyoNo ?? "");
    methods.setValue("juchuYmd", juchuWork.juchuYmd ?? "");
    methods.setValue("nohinyoteiYmd", juchuWork.nohinyoteiYmd ?? "");
    methods.setValue("tokuiShokuchiKbn", juchuWork.tokuiShokuchiKbn ?? "");
    methods.setValue("tokuiCd", juchuWork.tokuiCd ?? "");
    methods.setValue("tokuishitenCd", juchuWork.tokuishitenCd ?? "");
    methods.setValue("tokuiNm", juchuWork.tokuiNm ?? "");
    methods.setValue("tankaKakeritsu", juchuWork.tankaKakeritsu ?? "");
    methods.setValue("zeimarumeKbn", Number(juchuWork.zeimarumeKbn));
    methods.setValue("kinmarumeKbn", Number(juchuWork.kinmarumeKbn));
    methods.setValue("tokuiPostCd", juchuWork.tokuiPostCd ?? "");
    methods.setValue("tokuiAddress1", juchuWork.tokuiAddress1 ?? "");
    methods.setValue("tokuiAddress2", juchuWork.tokuiAddress2 ?? "");
    methods.setValue("tokuiTelNo", juchuWork.tokuiTelNo ?? "");
    methods.setValue("tokuiFaxNo", juchuWork.tokuiFaxNo ?? "");
    methods.setValue("nonyuShokuchiKbn", Number(juchuWork.nonyuShokuchiKbn));
    methods.setValue("nonyuCd", juchuWork.nonyuCd ?? "");
    methods.setValue("nonyushitenCd", juchuWork.nonyushitenCd ?? "");
    methods.setValue("nonyuNm", juchuWork.nonyuNm ?? "");
    methods.setValue("nonyuPostCd", juchuWork.nonyuPostCd ?? "");
    methods.setValue("nonyuAddress1", juchuWork.nonyuAddress1 ?? "");
    methods.setValue("nonyuAddress2", juchuWork.nonyuAddress2 ?? "");
    methods.setValue("nonyuTelNo", juchuWork.nonyuTelNo ?? "");
    methods.setValue("nonyuFaxNo", juchuWork.nonyuFaxNo ?? "");
    methods.setValue("ediMemo", juchuWork.ediMemo ?? "");
    methods.setValue("shainCd", juchuWork.shainCd ?? "");
    methods.setValue("shainNm", juchuWork.shainNm ?? "");
    methods.setValue("eigyoCd", juchuWork.eigyoCd ?? "");
    methods.setValue("seisakuYmd", juchuWork.seisakuYmd ?? "");
    methods.setValue("shukayoteiYmd", juchuWork.shukayoteiYmd ?? "");
    methods.setValue("jisanYmd", juchuWork.jisanYmd ?? "");
    methods.setValue("denpyoYmd", juchuWork.denpyoYmd ?? "");
    methods.setValue("shimeD", juchuWork.shimeD ?? "");
    methods.setValue("chohaKbn", getSCode(ChohaKbn, juchuWork.chohaKbn));
    methods.setValue("hasosakiCd", getSCode(HasosakiCd, juchuWork.hasosakiCd));
    methods.setValue("hasokbnCd", getSCode(HasokbnCd, juchuWork.hasokbnCd));
    methods.setValue("zeiKbnView", getSCode(ZeiKbn, juchuWork.zeiKbn));
    methods.setValue("zeiKbn", juchuWork.zeiKbn ?? "");
    methods.setValue("assistantCd", juchuWork.assistantCd ?? "");
    methods.setValue("assistantNm", juchuWork.assistantNm ?? "");
    methods.setValue("denpyoshubetsuCd", juchuWork.denpyoshubetsuCd ?? "");
    methods.setValue("denpyoshubetsuNm", juchuWork.denpyoshubetsuNm ?? "");
    methods.setValue("tenpudenpyoCd", juchuWork.tenpudenpyoCd ?? "");
    methods.setValue("tenpudenpyoNm", juchuWork.tenpudenpyoNm ?? "");
    methods.setValue("bunrui", juchuWork.bunrui ?? "");
    methods.setValue("unsogaishaCd", juchuWork.unsogaishaCd ?? "");
    methods.setValue("unsogaishaNm", juchuWork.unsogaishaNm ?? "");
    methods.setValue("bumonCd", juchuWork.bumonCd ?? "");
    methods.setValue("bumonNm", juchuWork.bumonNm ?? "");
    methods.setValue("ppgakeKbn", getSCode(PpgakeKbn, juchuWork.ppgakeKbn));
    methods.setValue("netsukeKbn", getSCode(NetsukeKbn, juchuWork.netsukeKbn));
    methods.setValue("chumonNo", juchuWork.chumonNo ?? "");
    methods.setValue("denpyoKbn", juchuWork.denpyoKbn ?? "");
    methods.setValue("ritsu", juchuWork.ritsu ?? "");
    methods.setValue("hinbetsuNo", juchuWork.hinbetsuNo ?? "");
    methods.setValue("tantosha", juchuWork.tantosha ?? "");
    methods.setValue("bikoCd", juchuWork.bikoCd ?? "");
    methods.setValue("biko", juchuWork.biko ?? "");
    methods.setValue("bikoCdBefore", juchuWork.bikoCd ?? "");
    methods.setValue("nohinsaki", juchuWork.nohinsaki ?? "");
    methods.setValue("lineCd", juchuWork.lineCd ?? "");
    methods.setValue("lineNm", juchuWork.lineNm ?? "");
    methods.setValue("uribaNm", juchuWork.uribaNm ?? "");
    methods.setValue("naisen", juchuWork.naisen ?? "");
    methods.setValue("ediJuchuNo", juchuWork.ediJuchuNo ?? "");
    methods.setValue("ediKbn", juchuWork.ediJuchuKbn ?? "");
    methods.setValue("version", juchuWork.version ?? "");
    methods.setValue("zeiRitsu", juchuWork.zeiRitsu ?? "");
    methods.setValue("jodaihyojiKbn", juchuWork.jodaihyojiKbn ?? "");
    methods.setValue("tankamarumeKbn", juchuWork.tankamarumeKbn ?? "");
    methods.setValue("tankahasuichi", juchuWork.tankahasuichi ?? "");

    // 明細テーブル設定
    if (juchuWork.b010070GetMeiResponse === null) return;

    // カラム「受注生産品」を設定するため、商品種別のチェック結果を配列に保持
    const juchuSeisanhinKbnList: string[] = juchuWork.b010070GetMeiResponse.map(
      (value) => {
        let isJuchuSeisanhinKbn = "";

        // 受注生産品を含む場合
        if (Number(value.shohinshubetsuKbn) === shohinshubetsuKbn.madeToOrder) {
          isJuchuSeisanhinKbn = juchuSeisanhinKbn.ari;
        }
        // 受注生産品を含まない場合
        else {
          isJuchuSeisanhinKbn = juchuSeisanhinKbn.nashi;
        }

        return isJuchuSeisanhinKbn;
      }
    );

    const juchuMei = juchuWork.b010070GetMeiResponse.map<Data>((value, i) => {
      // ベース単価の算出
      let basejodaitanka: string;
      let basejuchutanka: string;
      // セット商品の場合
      if (Number(value.setshohinKbn) === setshohinKbn.set) {
        // 上代単価
        basejodaitanka = value.setJodaitanka;
        // 下代単価
        basejuchutanka = getJuchutanka(
          methods,
          basejodaitanka,
          value.kakeritsu
        );
      }
      // セット商品以外の場合
      else {
        // 単価区分「0:通常単価」の場合
        if (Number(value.tankaKbn) === tankaKbn.tujo) {
          // 取引先別単価マスタ.上代単価が取得できた場合
          if (value.toritankaJodaitanka !== null) {
            // 上代単価
            basejodaitanka = getJodaitanka(methods, value.toritankaJodaitanka);
            // 下代単価
            basejuchutanka = getUchizeiJuchutanka(
              methods,
              value.toritankaTanka
            );
          }
          // 取得できなかった場合
          else {
            // 上代単価
            basejodaitanka = getJodaitanka(methods, value.tankaTanka);
            // 下代単価
            basejuchutanka = getJuchutanka(
              methods,
              basejodaitanka,
              value.kakeritsu
            );
          }
        }
        // 単価区分「1:WH単価」の場合
        else {
          // 上代単価
          basejodaitanka = value.whJodaitanka;
          // 下代単価
          basejuchutanka = getJuchutanka(
            methods,
            basejodaitanka,
            value.kakeritsu
          );
        }
      }

      const mei: Data = {
        juchugyoNo: Number(value.juchugyoNo),
        uchiwakeKbnView: getSCode(JuchuUchiwakeKbn, value.uchiwakeKbn)?.label,
        uchiwakeKbn: value.uchiwakeKbn,
        juchuSeisanhinKbnView: getSCode(
          JuchuSeisanhinKbn,
          juchuSeisanhinKbnList[i]
        )?.label,
        juchuSeisanhinKbn: juchuSeisanhinKbnList[i],
        shohinCd: value.shohinCd ?? "",
        janCd: value.janCd ?? "",
        shohinNm: value.shohinNm ?? "",
        edishohinNm: value.edishohinNm ?? "",
        aiteCd: value.aiteCd ?? "",
        sokoCd: value.sokoCd ?? "",
        sokoNm: value.sokoNm ?? "",
        vol: value.vol,
        sotosunW: value.sotosunW ?? "",
        sotosunH: value.sotosunH ?? "",
        uchisunW: value.uchisunW ?? "",
        uchisunH: value.uchisunH ?? "",
        juchusu: value.juchusu ?? "",
        kanosu: value.kanosu ?? "",
        tenyuryokujodaiKbn: Number(value.tenyuryokujodaiKbn),
        tenyuryokujuchuKbn: Number(value.tenyuryokujuchuKbn),
        basejodaitanka,
        basejuchutanka,
        jodaitanka: value.jodaitanka ?? "",
        juchutanka: value.juchutanka ?? "",
        kakeritsu: value.kakeritsu ?? "",
        juchuKin: value.juchuKin ?? "",
        meisaibikoCd: value.meisaibikoCd ?? "",
        meisaibiko: value.meisaibiko ?? "",
        kazeiKbn: Number(value.kazeiKbn),
        setshohinKbn: Number(value.setshohinKbn),
        shohinshubetsuKbn: Number(value.shohinshubetsuKbn),
        tankaKbn: Number(value.tankaKbn),
        shokuchiKbn: Number(value.shokuchiKbn),
        whtankaCd: value.whtankaCd ?? "",
        sokoshubetsuKbn: Number(value.sokoshubetsuKbn),
        crtshainCd: value.crtshainCd ?? "",
        crtDate: value.crtDate ?? "",
        koseiData: [],
      };
      // 構成データ設定
      if (value.b010070GetMeiKoseiResponse === null) {
        return mei;
      }
      mei.koseiData = value.b010070GetMeiKoseiResponse.map<KoseiData>(
        (value) => {
          // ベース単価の算出
          let setBasejodaitanka: string;
          let setBasejuchutanka: string;

          // セット商品マスタ.上代単価が取得できた場合
          if (value.setJodaitanka !== null) {
            // 上代単価
            setBasejodaitanka = value.setJodaitanka;
            // 下代単価
            setBasejuchutanka = getJuchutanka(
              methods,
              setBasejodaitanka,
              value.kakeritsu
            );
          }
          // セット商品マスタ.上代単価が取得できなかった場合
          else {
            // 単価区分「0:通常単価」の場合
            if (Number(value.tankaKbn) === tankaKbn.tujo) {
              // 取引先別単価マスタ.上代単価が取得できた場合
              if (value.toritankaJodaitanka !== null) {
                // 上代単価
                setBasejodaitanka = getJodaitanka(
                  methods,
                  value.toritankaJodaitanka
                );
                // 下代単価
                setBasejuchutanka = getUchizeiJuchutanka(
                  methods,
                  value.toritankaTanka
                );
              }
              // 取得できなかった場合
              else {
                // 上代単価
                setBasejodaitanka = getJodaitanka(methods, value.tankaTanka);
                // 下代単価
                setBasejuchutanka = getJuchutanka(
                  methods,
                  setBasejodaitanka,
                  value.kakeritsu
                );
              }
            }
            // 単価区分「1:WH単価」の場合
            else {
              // 上代単価
              setBasejodaitanka = value.whJodaitanka;
              // 下代単価
              setBasejuchutanka = getJuchutanka(
                methods,
                setBasejodaitanka,
                value.kakeritsu
              );
            }
          }

          const meiKosei: KoseiData = {
            juchugyoNo: Number(value.juchugyoNo),
            juchukoseigyoNo: Number(value.juchukoseigyoNo),
            shohinCd: value.shohinCd ?? "",
            janCd: value.janCd ?? "",
            shohinNm: value.shohinNm ?? "",
            aiteCd: value.aiteCd ?? "",
            sokoCd: value.sokoCd ?? "",
            sokoNm: value.sokoNm ?? "",
            vol: value.vol ?? "",
            sotosunW: value.sotosunW ?? "",
            sotosunH: value.sotosunH ?? "",
            uchisunW: value.uchisunW ?? "",
            uchisunH: value.uchisunH ?? "",
            hitsuyosu: value.hitsuyosu ?? "",
            koseisu: value.koseisu ?? "",
            kanosu: value.kanosu ?? "",
            tenyuryokujodaiKbn: Number(value.tenyuryokujodaiKbn),
            tenyuryokujuchuKbn: Number(value.tenyuryokujuchuKbn),
            basejodaitanka: setBasejodaitanka,
            basejuchutanka: setBasejuchutanka,
            jodaitanka: value.jodaitanka ?? "",
            juchutanka: value.juchutanka ?? "",
            kakeritsu: value.kakeritsu ?? "",
            juchuKin: value.juchuKin ?? "",
            meisaikoseiBikoCd: value.meisaikoseiBikoCd ?? "",
            meisaikoseiBiko: value.meisaikoseiBiko ?? "",
            kazeiKbn: Number(value.kazeiKbn),
            shohinshubetsuKbn: Number(value.shohinshubetsuKbn),
            tankaKbn: Number(value.tankaKbn),
            shokuchiKbn: Number(value.shokuchiKbn),
            whtankaCd: value.whtankaCd ?? "",
            sokoshubetsuKbn: Number(value.sokoshubetsuKbn),
            crtDate: value.crtDate ?? "",
            crtshainCd: value.crtshainCd ?? "",
          };
          return meiKosei;
        }
      );
      return mei;
    });
    // テーブルに反映
    setRows(juchuMei);
  }, []);

  // 初期表示(共通)
  useEffect(() => {
    (async () => {
      // 消費税取得
      await B010010ZeiRitsu(methods);
      // フォーカス
      switch (methods.watch("editKbn")) {
        case editKbn.update:
          focus(1);
          break;
      }
    })();
  }, []);

  // 明細変更
  useEffect(() => {
    //合計金額算出
    handleGokeiCalculating();
  }, [rows]);

  // 発送日変更時(カレンダー選択時にshukayoteiYmdを受け取る)
  const handleChangeShukayoteiYmd = (
    shukayoteiYmd: string = methods.getValues().shukayoteiYmd!
  ) => {
    // 未入力OR不正な値の場合、何もしない
    if (shukayoteiYmd === "" || !validDate(shukayoteiYmd!)) return;

    methods.setValue("denpyoYmd", shukayoteiYmd);
    // 伝票日付の変更処理を呼び出す
    handleChangeDenpyoYmd();
  };

  // 伝票日付変更時(カレンダー選択時にdenpyoYmdを受け取る)
  const handleChangeDenpyoYmd = (
    denpyoYmd: string = methods.getValues().denpyoYmd!
  ) => {
    // 未入力OR不正な値の場合、何もしない
    if (denpyoYmd === "" || !validDate(denpyoYmd!)) return;

    (async () => {
      // 消費税取得
      await B010010ZeiRitsu(methods);

      // 明細入力部の単価再設定
      reacquisitionMeiTanka();

      // 明細が登録されている場合
      if (rows.length > 0) {
        // 明細再設定
        // 上代単価、下代単価が変更されていない商品コードを取得(重複排除)
        const shohinCdList: string[] = Array.from(
          new Set(
            rows
              // 手入力区分をチェック
              .filter(
                (row) => row.tenyuryokujodaiKbn === tenyuryokujodaiKbn.none
              )
              .filter(
                (row) => row.tenyuryokujuchuKbn === tenyuryokujuchuKbn.none
              )
              // セット商品区分をチェック
              .filter((row) => row.setshohinKbn === setshohinKbn.single)
              // 単価区分をチェック
              .filter((row) => row.tankaKbn === tankaKbn.tujo)
              .map((row) => row.shohinCd!)
          )
        );

        // 再設定する行が存在する場合
        if (shohinCdList.length > 0) {
          // 単価マスタより再取得を行う
          B010010TankaList(
            methods,
            shohinCdList,
            rows,
            setRows,
            navigate,
            setMsg
          );
        }
        // 再設定する行が存在しない場合
        else {
          // 合計値(rowsに変更が無いため、明示的に処理を呼ぶ)
          handleGokeiCalculating();
        }
      }
    })();
  };

  // 明細入力部の単価再設定
  const reacquisitionMeiTanka = () => {
    // フォームのデータを取得する。
    const meiFields = meiMethods.getValues();
    // 明細入力部が設定されていない場合(商品種別区分で判断)
    if (meiFields.shohinshubetsuKbn === undefined) return;

    // 手入力上代区分が「1:あり」の場合
    if (meiFields.tenyuryokujodaiKbn === tenyuryokujodaiKbn.exists) return;

    // 手入力受注区分が「1:あり」の場合
    if (meiFields.tenyuryokujuchuKbn === tenyuryokujuchuKbn.exists) return;

    // セット商品区分が「1:セット品」の場合
    if (meiFields.setshohinKbn === setshohinKbn.set) return;

    // 単価区分が「1:WH単価」の場合
    if (meiFields.tankaKbn === tankaKbn.wh) return;

    // 単価再取得処理を行う
    B010010Tanka(methods, meiMethods, navigate, setMsg);
  };

  // 得意先変更(得意先コード、得意先支店コード)
  const handleChangeTokui = () => {
    // フォームのデータを取得する。
    const fields = methods.getValues();
    if (fields.tokuiCd === "" || fields.tokuishitenCd === "") {
      methods.setValue("tokuiShokuchiKbn", "");
      methods.setValue("tokuiNm", "");
      methods.setValue("tokuiPostCd", "");
      methods.setValue("tokuiAddress1", "");
      methods.setValue("tokuiAddress2", "");
      methods.setValue("tokuiTelNo", "");
      methods.setValue("tokuiFaxNo", "");
      methods.setValue("shainCd", "");
      methods.setValue("bumonCd", "");
      methods.setValue("shimeD", "");
      methods.setValue("zeiKbnView", getSCode(ZeiKbn, ""));
      methods.setValue("zeiKbn", "");
      methods.setValue("zeimarumeKbn", undefined);
      methods.setValue("jodaihyojiKbn", "");
      methods.setValue("kinmarumeKbn", undefined);
      methods.setValue("tankamarumeKbn", "");
      methods.setValue("tankahasuichi", "");
      methods.setValue("tankaKakeritsu", "");
      return;
    }

    if (
      !methods.getFieldState("tokuiCd").isDirty &&
      !methods.getFieldState("tokuishitenCd").isDirty
    ) {
      return;
    }

    // 得意先関連項目設定
    B010010Tokui(methods, navigate, setMsg);
    methods.unregister("tokuiCd", { keepValue: true });
    methods.unregister("tokuishitenCd", { keepValue: true });
  };

  // 納入先変更(得意先コード、得意先支店コード)
  const handleChangeNonyu = () => {
    // フォームのデータを取得する。
    const fields = methods.getValues();
    if (fields.nonyuCd === "" || fields.nonyushitenCd === "") {
      methods.setValue("nonyuShokuchiKbn", undefined);
      methods.setValue("nonyuNm", "");
      methods.setValue("nonyuPostCd", "");
      methods.setValue("nonyuAddress1", "");
      methods.setValue("nonyuAddress2", "");
      methods.setValue("nonyuTelNo", "");
      methods.setValue("nonyuFaxNo", "");
      return;
    }

    if (
      !methods.getFieldState("nonyuCd").isDirty &&
      !methods.getFieldState("nonyushitenCd").isDirty
    ) {
      return;
    }

    // 納入先関連項目設定
    B010010Nonyu(methods, navigate, setMsg);
    methods.unregister("nonyuCd", { keepValue: true });
    methods.unregister("nonyushitenCd", { keepValue: true });
  };

  // 下代、受注金額設定
  const handleCalcJuchutankaJuchuKin = () => {
    // フォームのデータを取得する。
    const meiFields = meiMethods.getValues();

    // 上代単価、掛率が未入力の場合
    if (meiFields.jodaitanka === "") return;

    if (meiFields.kakeritsu === "") return;

    // 手入力受注区分が「1:有り」の場合
    if (!isTenyuryokujuchuKbn) {
      return;
    }

    // 下代単価取得
    const juchutanka: string = getJuchutanka(
      methods,
      meiFields.jodaitanka!,
      meiFields.kakeritsu!
    );
    // 下代単価
    meiMethods.setValue("juchutanka", juchutanka);
    // ベース下代単価
    meiMethods.setValue("basejuchutanka", juchutanka);

    // 受注金額
    handleCalcJuchuKin();
  };

  // 受注金額設定
  const handleCalcJuchuKin = () => {
    // フォームのデータを取得する。
    const fields = methods.getValues();
    const meiFields = meiMethods.getValues();
    // 受注金額
    meiMethods.setValue(
      "juchuKin",
      getJuchuKin(
        meiFields.juchutanka!,
        meiFields.juchusu!,
        fields.kinmarumeKbn!
      )
    );
  };

  // 受注数変更
  const handleChangeJuchusu = () => {
    // フォームのデータを取得する。
    const fields = methods.getValues();
    const meiFields = meiMethods.getValues();

    // セット構成品が存在する場合
    if (Object.keys(b010012Props!.data!).length !== 0) {
      // 構成品データの更新
      const newRows = meiFields.koseiData?.map((koseiRow: KoseiData) => {
        // 必要数
        koseiRow.hitsuyosu = getHitsuyosu(
          koseiRow.koseisu!,
          meiFields.juchusu!
        );

        // 構成品.受注金額
        koseiRow.juchuKin = getJuchuKin(
          koseiRow.juchutanka!,
          koseiRow.hitsuyosu!,
          fields.kinmarumeKbn!
        );
        return koseiRow;
      });
      meiMethods.setValue("koseiData", newRows);
    }

    // 受注金額
    meiMethods.setValue(
      "juchuKin",
      getJuchuKin(
        meiFields.juchutanka!,
        meiFields.juchusu!,
        fields.kinmarumeKbn!
      )
    );
  };

  // 倉庫コード変更
  const handleChangeSokoCd = () => {
    (async () => {
      // 倉庫名表示
      await B000190SokoNmSokoshubetsuKbn(meiMethods, navigate, setMsg);
      // 引当可能数取得処理
      await B010010Kanosu(meiMethods, navigate, setMsg);
    })();
  };

  // タブ切替
  const handleChangeMeiTab = () => {
    if (!meiMethods.watch("meiTab")) return;
    meiMethods.reset();
    meiMethods.reset({
      ...meiMethods.getValues(),
      shohinCd: "",
      janCd: "",
    });
    meiMethods.setValue("meiTab", true);
  };

  //  ダイアログ表示用（更新）
  const handleOpenUpdateConfirm = () => {
    if (meiMethods.formState.isDirty) {
      setOpenUpdateConfirm(true);
    } else {
      handleClickUpdateButton();
    }
  };

  // キャンセル押下時（更新）
  const handleCancelUpdateConfirm = () => {
    setOpenUpdateConfirm(false);
  };

  // 更新
  const handleClickUpdateButton = () => {
    setOpenUpdateConfirm(false);

    B010060Update(methods, rows)
      .then(() => {
        // フォームのデータを取得する。
        const fields = methods.getValues();
        // versionを更新する
        const version = (Number(fields.version) + 1).toString();
        methods.setValue("version", version);

        setMsg(getClientMessage("B010060_001"));
      })
      .catch((reason) => {
        catchRestError(reason, navigate, setMsg);
      });
  };

  // 明細登録
  const handleClickCreateMeiButton = () => {
    // 独自チェック
    if (invalidated()) return;

    // TODO: react-formのエラーチェック
    // フィールドチェック
    meiMethods.handleSubmit(() => {
      // 明細に設定するデータを取得
      const juchugyoNo: number = rows.length + 1;
      const data: Data = handleDataMapping(juchugyoNo);

      // 明細を設定
      setRows([...rows, data]);
      setRowCount(juchugyoNo);

      // 明細クリア
      meiMethods.reset();
      meiMethods.reset({
        ...meiMethods.getValues(),
        shohinCd: "",
        janCd: "",
      });
      focus(38);
    })();
  };

  // 明細更新
  const handleClickUpdateMeiButton = () => {
    // 独自チェック
    if (invalidated()) return;

    // TODO: react-formのエラーチェック
    // フィールドチェック
    meiMethods.handleSubmit(
      () => {
        const juchugyoNo: number = rowData?.juchugyoNo!;
        // 明細に設定するデータを取得
        const data: Data = handleDataMapping(juchugyoNo);
        // 明細を設定
        rows[juchugyoNo - 1] = data;
        setRows([...rows]);

        // 行選択の解除
        setRowData(undefined);

        // 明細クリア
        meiMethods.reset();
        meiMethods.reset({
          ...meiMethods.getValues(),
          shohinCd: "",
          janCd: "",
        });

        // 明細入力部を新規登録に変更する
        meiMethods.setValue("meiTab", true);
      },
      (errors, event) => {
        console.log(errors);
      }
    )();
  };

  // 独自チェック
  const invalidated = (): boolean => {
    // フォームのデータを取得する。
    const meiFields = meiMethods.getValues();
    // 行番号
    const juchugyoNo: number = rowData?.juchugyoNo ?? rows.length + 1;

    // 受注数が0以下の場合
    if (Number(meiFields.juchusu) <= juchusuMin) {
      setMsg(getClientError("B010060_001"));
      return true;
    }

    // 掛率が0～999以外の場合
    if (
      !(
        Number(meiFields.kakeritsu) >= KakerituRangeMin &&
        Number(meiFields.kakeritsu) <= KakerituRangeMax
      )
    ) {
      setMsg(getClientError("B010060_002"));
      return true;
    }

    // 受注金額が9桁より大きい場合
    if (meiFields.juchuKin!.length > juchuKinMaxLength) {
      setMsg(getClientError("B010060_003"));
      return true;
    }

    // 上代合計・下代合計の金額が9桁より大きい場合エラー
    // 上代合計(現在編集中の行を除いた合計値を取得)
    const jodaitankaGokei: string = rows
      .filter(function (source: Data) {
        return Number(source.juchugyoNo) !== juchugyoNo;
      })
      .reduce((acc: Big, row: Data): Big => {
        return acc.plus(new Big(row.jodaitanka ? row.jodaitanka : "0"));
      }, new Big("0"))
      .plus(new Big(meiFields.jodaitanka ? meiFields.jodaitanka : "0"))
      .toString();
    // 受注金額が9桁より大きい場合
    if (jodaitankaGokei.length > jodaitankaMaxLength) {
      setMsg(getClientError("B010060_004"));
      return true;
    }

    // 下代合計(現在編集中の行を除いた合計値を取得)
    const juchutankaGokei: string = rows
      .filter(function (source: Data) {
        return Number(source.juchugyoNo) !== juchugyoNo;
      })
      .reduce((acc: Big, row: Data): Big => {
        return acc.plus(new Big(row.juchutanka ? row.juchutanka : "0"));
      }, new Big("0"))
      .plus(new Big(meiFields.juchutanka ? meiFields.juchutanka : "0"))
      .toString();
    // 受注金額が9桁より大きい場合
    if (juchutankaGokei.length > juchutankaMaxLength) {
      setMsg(getClientError("B010060_005"));
      return true;
    }

    // 商品種別区分が「9:材料品」の場合
    if (meiFields.shohinshubetsuKbn! === shohinshubetsuKbn.materials) {
      setMsg(getClientError("B010060_006"));
      return true;
    }

    // 倉庫が物流倉庫、引当倉庫以外の場合
    if (
      !(
        meiFields.sokoshubetsuKbn === sokoshubetsuKbn.logicalSoko ||
        meiFields.sokoshubetsuKbn === sokoshubetsuKbn.hikiateSoko
      )
    ) {
      setMsg(getClientError("B010060_007"));
      return true;
    }

    // 外寸の入力値チェック
    if (meiFields.sotosunH || meiFields.sotosunW) {
      // 外寸が片方だけ入力されている場合エラー
      if (!meiFields.sotosunW) {
        setMsg(getClientError("B010060_008"));
        return true;
      }
      if (!meiFields.sotosunH) {
        setMsg(getClientError("B010060_009"));
        return true;
      }
    }
    // 内寸の入力値チェック
    if (meiFields.uchisunH || meiFields.uchisunW) {
      // 内寸が片方だけ入力されている場合エラー
      if (!meiFields.uchisunW) {
        setMsg(getClientError("B010060_012"));
        return true;
      }
      if (!meiFields.uchisunH) {
        setMsg(getClientError("B010060_013"));
        return true;
      }
    }

    // WH単価の商品の場合
    if (meiFields.tankaKbn === tankaKbn.wh) {
      // 外寸が入っていない場合
      if (!meiFields.sotosunW) {
        setMsg(getClientError("B010060_016"));
        return true;
      }
      if (!meiFields.sotosunH) {
        setMsg(getClientError("B010060_016"));
        return true;
      }
      // 外寸が0以下の場合
      if (Number(meiFields.sotosunW) <= whMin) {
        setMsg(getClientError("B010060_010"));
        return true;
      }
      if (Number(meiFields.sotosunH) <= whMin) {
        setMsg(getClientError("B010060_011"));
        return true;
      }
    }

    return false;
  };

  // 明細のデータマッピング
  const handleDataMapping = (juchugyoNo: number): Data => {
    // フォームのデータを取得する。
    const meiFields = meiMethods.getValues();

    const data: Data = {
      juchugyoNo,
      uchiwakeKbnView: meiFields.uchiwakeKbn?.label,
      uchiwakeKbn: meiFields.uchiwakeKbn?.value,
      juchuSeisanhinKbnView: meiFields.juchuSeisanhinKbn?.label,
      juchuSeisanhinKbn: meiFields.juchuSeisanhinKbn?.value,
      shohinCd: meiFields.shohinCd,
      janCd: meiFields.janCd,
      shohinNm: meiFields.shohinNm,
      edishohinNm: meiFields.edishohinNm,
      aiteCd: meiFields.aiteCd,
      sokoCd: meiFields.sokoCd,
      sokoNm: meiFields.sokoNm,
      vol: meiFields.vol,
      sotosunW: meiFields.sotosunW,
      sotosunH: meiFields.sotosunH,
      uchisunW: meiFields.uchisunW,
      uchisunH: meiFields.uchisunH,
      juchusu: meiFields.juchusu,
      kanosu: meiFields.kanosu,
      // 手入力上代区分の設定(一致する場合「0：変更なし」、一致する場合「1：変更あり」)
      tenyuryokujodaiKbn: isTenyuryokujodaiKbn
        ? tenyuryokujodaiKbn.none
        : tenyuryokujodaiKbn.exists,
      // 手入力受注区分の設定(一致する場合「0：変更なし」、一致する場合「1：変更あり」)
      tenyuryokujuchuKbn: isTenyuryokujuchuKbn
        ? tenyuryokujuchuKbn.none
        : tenyuryokujuchuKbn.exists,
      basejodaitanka: meiFields.basejodaitanka,
      basejuchutanka: meiFields.basejuchutanka,
      jodaitanka: meiFields.jodaitanka,
      juchutanka: meiFields.juchutanka,
      kakeritsu: meiFields.kakeritsu,
      juchuKin: meiFields.juchuKin,
      meisaibikoCd: meiFields.meisaibikoCd,
      meisaibiko: meiFields.meisaibiko,
      kazeiKbn: meiFields.kazeiKbn,
      setshohinKbn: meiFields.setshohinKbn,
      shohinshubetsuKbn: meiFields.shohinshubetsuKbn,
      tankaKbn: meiFields.tankaKbn,
      shokuchiKbn: meiFields.shokuchiKbn,
      whtankaCd: meiFields.whtankaCd,
      sokoshubetsuKbn: meiFields.sokoshubetsuKbn,
      crtshainCd: meiFields.crtshainCd,
      crtDate: meiFields.crtDate,
      koseiData: meiFields.koseiData?.map(
        // 構成データに受注行番号を設定
        (source: KoseiData) => {
          source.juchugyoNo = juchugyoNo;
          return source;
        }
      ),
    };

    return data;
  };

  // 明細削除
  const handleClickDeleteMeiButton = () => {
    // 選択行の取得
    if (typeof rowData?.juchugyoNo === "undefined") return;
    const juchugyoNo: number = rowData.juchugyoNo;
    // 対象の行を削除
    const newRows = rows
      .filter(function (source: Data) {
        return source.juchugyoNo !== juchugyoNo;
      })
      // 明細の連番の振り直し
      .map((meiRow: any, index) => {
        // 明細
        meiRow.juchugyoNo = ++index;
        // セット商品以外の場合
        if (meiRow.setshohinKbn === setshohinKbn.single) {
          // 何もしない
          return meiRow;
        }
        // セット構成品の受注行番号を再設定
        meiRow.koseiData.map((koseiRow: any) => {
          koseiRow.juchugyoNo = index;
          return koseiRow;
        });
        return meiRow;
      });

    setRows(newRows);

    // 行選択の解除
    setRowData(undefined);

    // 明細クリア
    meiMethods.reset();
    meiMethods.reset({
      ...meiMethods.getValues(),
      shohinCd: "",
      janCd: "",
    });

    // 明細入力部を新規登録に変更する
    meiMethods.setValue("meiTab", true);
  };

  //合計金額算出
  const handleGokeiCalculating = () => {
    // 明細が設定されていない場合
    if (rows.length === 0) {
      // 合計金額の初期化のみ行う
      methods.setValue("juchuKinGokei", "");
      methods.setValue("zeiGokei", "");
      methods.setValue("denpyoGokei", "");
      return;
    }

    // フォームのデータを取得する。
    const fields = methods.getValues();

    // 受注金額合計
    const juchuKinGokei: Big = rows.reduce((acc: Big, row: Data): Big => {
      return acc.plus(new Big(row.juchuKin ? row.juchuKin : "0"));
    }, new Big("0"));

    // 消費税
    let zeiGokei: Big = new Big(0);
    // 消費税区分が「0」(外税/明細単位)の場合
    if (fields.zeiKbn === zeiKbn.sotozeiMei) {
      // 税丸め区分を取得
      let zeiRoundingMode: RoundingMode;
      // 四捨五入
      if (fields.zeimarumeKbn === zeimarumeKbn.shishagonyu) {
        zeiRoundingMode = Big.roundHalfUp;
      }
      //切り捨て
      else if (fields.zeimarumeKbn === zeimarumeKbn.kirisute) {
        zeiRoundingMode = Big.roundDown;
      }
      //切り上げ
      else if (fields.zeimarumeKbn === zeimarumeKbn.kiriage) {
        zeiRoundingMode = Big.roundUp;
      }

      // 消費税合計 ※小数点以下は得意先毎の丸め処理を行う
      zeiGokei = juchuKinGokei
        .times(new Big(fields.zeiRitsu ?? "0"))
        .div(new Big("100"))
        .round(0, zeiRoundingMode!);
    }
    // 消費税区分が「1」(外税/伝票単位)の場合
    if (fields.zeiKbn === zeiKbn.sotozeiDen) {
      // 税丸め区分を取得
      let zeiRoundingMode: RoundingMode;
      // 四捨五入
      if (fields.zeimarumeKbn === zeimarumeKbn.shishagonyu) {
        zeiRoundingMode = Big.roundHalfUp;
      }
      //切り捨て
      else if (fields.zeimarumeKbn === zeimarumeKbn.kirisute) {
        zeiRoundingMode = Big.roundDown;
      }
      //切り上げ
      else if (fields.zeimarumeKbn === zeimarumeKbn.kiriage) {
        zeiRoundingMode = Big.roundUp;
      }

      // 消費税合計 ※小数点以下は得意先毎の丸め処理を行う
      zeiGokei = juchuKinGokei
        .times(new Big(fields.zeiRitsu ?? "0"))
        .div(new Big("100"))
        .round(0, zeiRoundingMode!);
    }

    // 伝票合計
    const denpyoGokei: Big = juchuKinGokei.plus(zeiGokei);

    methods.setValue("juchuKinGokei", juchuKinGokei.toString());
    methods.setValue("zeiGokei", zeiGokei.toString());
    methods.setValue("denpyoGokei", denpyoGokei.toString());
  };

  // テーブル行ダブルクリックイベント
  const handleDoubleClickTableRow = (data: Data) => {
    // データを保存
    setRowData(data);
    if (typeof data.juchugyoNo !== "undefined") {
      // 明細入力部を編集に変更する
      meiMethods.setValue("meiTab", false);
      // 明細入力部に値を設定する
      meiMethods.setValue("juchugyoNo", data.juchugyoNo);
      meiMethods.setValue(
        "uchiwakeKbn",
        getSCode(JuchuUchiwakeKbn, data.uchiwakeKbn ?? "0")
      );
      meiMethods.setValue(
        "juchuSeisanhinKbn",
        getSCode(
          JuchuSeisanhinKbn,
          data.juchuSeisanhinKbn ?? juchuSeisanhinKbn.nashi
        )
      );
      meiMethods.setValue("shohinCd", data.shohinCd);
      meiMethods.setValue("janCd", data.janCd);
      meiMethods.setValue("shohinNm", data.shohinNm);
      meiMethods.setValue("aiteCd", data.aiteCd);
      meiMethods.setValue("sokoCd", data.sokoCd);
      meiMethods.setValue("sokoNm", data.sokoNm);
      meiMethods.setValue("vol", data.vol);
      meiMethods.setValue("sotosunW", data.sotosunW);
      meiMethods.setValue("sotosunH", data.sotosunH);
      meiMethods.setValue("uchisunW", data.uchisunW);
      meiMethods.setValue("uchisunH", data.uchisunH);
      meiMethods.setValue("juchusu", data.juchusu);
      meiMethods.setValue("kanosu", data.kanosu);
      meiMethods.setValue("tenyuryokujodaiKbn", data.tenyuryokujodaiKbn);
      meiMethods.setValue("tenyuryokujuchuKbn", data.tenyuryokujuchuKbn);
      meiMethods.setValue("basejodaitanka", data.basejodaitanka);
      meiMethods.setValue("basejuchutanka", data.basejuchutanka);
      meiMethods.setValue("jodaitanka", data.jodaitanka);
      meiMethods.setValue("juchutanka", data.juchutanka);
      meiMethods.setValue("kakeritsu", data.kakeritsu);
      meiMethods.setValue("juchuKin", data.juchuKin);
      meiMethods.setValue("meisaibikoCd", data.meisaibikoCd);
      meiMethods.setValue("meisaibikoCdBefore", data.meisaibikoCd);
      meiMethods.setValue("meisaibiko", data.meisaibiko);
      meiMethods.setValue(
        "kazeiKbnView",
        getSCode(HyoziKazeiKbn, data.kazeiKbn ?? "")?.label
      );
      meiMethods.setValue("kazeiKbn", data.kazeiKbn);
      meiMethods.setValue("setshohinKbn", data.setshohinKbn);
      meiMethods.setValue("edishohinNm", data.edishohinNm);
      meiMethods.setValue("crtDate", data.crtDate);
      meiMethods.setValue("crtshainCd", data.crtshainCd);
      meiMethods.setValue("shohinshubetsuKbn", data.shohinshubetsuKbn);
      meiMethods.setValue("tankaKbn", data.tankaKbn);
      meiMethods.setValue("shokuchiKbn", data.shokuchiKbn);
      meiMethods.setValue("whtankaCd", data.whtankaCd);
      meiMethods.setValue("sokoshubetsuKbn", data.sokoshubetsuKbn);
      meiMethods.setValue("koseiData", data.koseiData);
      focus(37);
    }
  };

  // 補足の引数を設定
  const getSupplementProps = () => {
    return {
      editKbn: methods.watch("editKbn"),
      juchudenpyoNo: methods.watch("juchudenpyoNo"),
      tokuiNm: methods.watch("tokuiNm"),
      tokuiPostCd: methods.watch("tokuiPostCd"),
      tokuiAddress1: methods.watch("tokuiAddress1"),
      tokuiAddress2: methods.watch("tokuiAddress2"),
      tokuiTelNo: methods.watch("tokuiTelNo"),
      tokuiFaxNo: methods.watch("tokuiFaxNo"),
      nonyuNm: methods.watch("nonyuNm"),
      nonyuPostCd: methods.watch("nonyuPostCd"),
      nonyuAddress1: methods.watch("nonyuAddress1"),
      nonyuAddress2: methods.watch("nonyuAddress2"),
      nonyuTelNo: methods.watch("nonyuTelNo"),
      nonyuFaxNo: methods.watch("nonyuFaxNo"),
      ediMemo: methods.watch("ediMemo"),
      nonyuShokuchiKbn: methods.watch("nonyuShokuchiKbn"),
    };
  };

  const b010012Props: B010012Props = {
    editKbn: editKbn.update,
    fields: {},
    data: [],
    meiMethods: meiMethods,
  };

  // セット構成品の引数を設定(呼び出し)
  const getKoseiProps = () => {
    b010012Props.fields = {
      setshohinCd: meiMethods.watch("shohinCd"),
      setshohinNm: meiMethods.watch("shohinNm"),
      juchusu: meiMethods.watch("juchusu"),
      zeiRitsu: methods.watch("zeiRitsu"),
      tokuiCd: methods.watch("tokuiCd"),
      denpyoYmd: methods.watch("denpyoYmd"),
      tokuishitenCd: methods.watch("tokuishitenCd"),
      zeimarumeKbn: methods.watch("zeimarumeKbn"),
      kinmarumeKbn: methods.watch("kinmarumeKbn"),
      tankamarumeKbn: methods.watch("tankamarumeKbn"),
      tankahasuichi: methods.watch("tankahasuichi"),
      zeiKbn: methods.watch("zeiKbn"),
      tankaKakeritsu: methods.watch("tankaKakeritsu"),
      jodaihyojiKbn: methods.watch("jodaihyojiKbn"),
      isJuchuWork: true,
    };
    b010012Props.data = meiMethods.watch("koseiData")?.map((value) => ({
      juchugyoNo: value.juchugyoNo,
      juchukoseigyoNo: value.juchukoseigyoNo,
      shohinCd: value.shohinCd,
      janCd: value.janCd,
      aiteCd: value.aiteCd,
      shohinNm: value.shohinNm,
      vol: value.vol,
      sotosunW: value.sotosunW,
      sotosunH: value.sotosunH,
      uchisunW: value.uchisunW,
      uchisunH: value.uchisunH,
      koseisu: value.koseisu,
      hitsuyosu: value.hitsuyosu,
      kanosu: value.kanosu,
      jodaitanka: value.jodaitanka,
      juchutanka: value.juchutanka,
      kakeritsu: value.kakeritsu,
      juchuKin: value.juchuKin,
      sokoCd: value.sokoCd,
      sokoNm: value.sokoNm,
      sokoshubetsuKbn: value.sokoshubetsuKbn,
      meisaikoseiBikoCd: value.meisaikoseiBikoCd,
      meisaikoseiBiko: value.meisaikoseiBiko,
      kazeiKbn: value.kazeiKbn,
      tenyuryokujodaiKbn: value.tenyuryokujodaiKbn,
      tenyuryokujuchuKbn: value.tenyuryokujuchuKbn,
      basejodaitanka: value.jodaitanka,
      basejuchutanka: value.juchutanka,
      shohinshubetsuKbn: value.shohinshubetsuKbn,
      tankaKbn: value.tankaKbn,
      shokuchiKbn: value.shokuchiKbn,
      whtankaCd: value.whtankaCd,
      setshohinKbn: value.setshohinKbn,
      crtDate: value.crtDate,
      crtshainCd: value.crtshainCd,
    }));

    return b010012Props;
  };

  // セット構成品の引数を設定(返却)
  const setKoseiProps = (b010012Props: B010012Props) => {
    const koseiDataList: KoseiData[] = [];

    // 受注数
    meiMethods.setValue("juchusu", b010012Props.fields?.juchusu);
    // 上代単価
    meiMethods.setValue("jodaitanka", b010012Props.fields?.setjodaitanka);
    // 下代単価
    meiMethods.setValue("juchutanka", b010012Props.fields?.setjuchutanka);

    // 掛率の再計算
    const kakeritsu: string = getKakeritsu(
      b010012Props.fields?.setjuchutanka!,
      b010012Props.fields?.setjodaitanka!
    );
    meiMethods.setValue("kakeritsu", kakeritsu);

    // 受注金額の再計算
    handleCalcJuchuKin();

    if (Object.keys(b010012Props!.data!).length === 0) {
      meiMethods.setValue("koseiData", koseiDataList);
      return;
    }

    // 構成品の中に受注生産品が含まれるかどうか
    const isJuchuSeisanhinKbn: boolean = b010012Props!.data!.some(
      (koseiData) =>
        koseiData.shohinshubetsuKbn === shohinshubetsuKbn.madeToOrder
    );

    meiMethods.setValue(
      "juchuSeisanhinKbn",
      getSCode(
        JuchuSeisanhinKbn,
        isJuchuSeisanhinKbn ? juchuSeisanhinKbn.ari : juchuSeisanhinKbn.nashi
      )
    );

    // 構成品データ
    for (let i: number = 0; i < b010012Props!.data!.length; i++) {
      const koseiData: KoseiData = {
        juchukoseigyoNo: b010012Props!.data![i].juchukoseigyoNo,
        shohinCd: b010012Props!.data![i].shohinCd,
        janCd: b010012Props!.data![i].janCd,
        shohinNm: b010012Props!.data![i].shohinNm,
        aiteCd: b010012Props!.data![i].aiteCd,
        sokoCd: b010012Props!.data![i].sokoCd,
        sokoNm: b010012Props!.data![i].sokoNm,
        vol: b010012Props!.data![i].vol,
        sotosunW: b010012Props!.data![i].sotosunW,
        sotosunH: b010012Props!.data![i].sotosunH,
        uchisunW: b010012Props!.data![i].uchisunW,
        uchisunH: b010012Props!.data![i].uchisunH,
        hitsuyosu: b010012Props!.data![i].hitsuyosu,
        koseisu: b010012Props!.data![i].koseisu,
        kanosu: b010012Props!.data![i].kanosu,
        tenyuryokujodaiKbn: b010012Props!.data![i].tenyuryokujodaiKbn,
        tenyuryokujuchuKbn: b010012Props!.data![i].tenyuryokujuchuKbn,
        basejodaitanka: b010012Props!.data![i].basejodaitanka,
        basejuchutanka: b010012Props!.data![i].basejuchutanka,
        jodaitanka: b010012Props!.data![i].jodaitanka,
        juchutanka: b010012Props!.data![i].juchutanka,
        kakeritsu: b010012Props!.data![i].kakeritsu,
        juchuKin: b010012Props!.data![i].juchuKin,
        meisaikoseiBikoCd: b010012Props!.data![i].meisaikoseiBikoCd,
        meisaikoseiBiko: b010012Props!.data![i].meisaikoseiBiko,
        kazeiKbn: b010012Props!.data![i].kazeiKbn,
        shohinshubetsuKbn: b010012Props!.data![i].shohinshubetsuKbn,
        tankaKbn: b010012Props!.data![i].tankaKbn,
        shokuchiKbn: b010012Props!.data![i].shokuchiKbn,
        whtankaCd: b010012Props!.data![i].whtankaCd,
        sokoshubetsuKbn: b010012Props!.data![i].sokoshubetsuKbn,
        crtDate: b010012Props!.data![i].crtDate,
        crtshainCd: b010012Props!.data![i].crtshainCd,
      };

      koseiDataList.push(koseiData);
    }

    meiMethods.setValue("koseiData", koseiDataList);

    // 明細入力部に表示する可能数の設定
    let kanosu: string = "";
    // 構成品に可能数の設定されている行があるかチェック
    const isKanosu: boolean = koseiDataList.some(
      (koseiData: KoseiData) => koseiData.kanosu !== ""
    );
    // 可能数の設定されている行がある場合
    if (isKanosu) {
      kanosu = Math.min(
        ...koseiDataList
          .filter(function (kosei: KoseiData) {
            return kosei.kanosu !== "";
          })
          .map((kosei: KoseiData) => Number(kosei.kanosu))
      ).toString();
    }
    meiMethods.setValue("kanosu", kanosu);
  };

  // レイアウト設定
  return (
    <>
      <FormProvider {...methods}>
        <SFrame
          title="受注ワーク入力"
          gridTemplateColumns="6rem 5rem 5rem 5rem 4rem 4rem 7rem 7rem 6rem 4rem 7rem 4rem 5rem 5rem 4rem"
        >
          <SInfoButton
            label={labels.buttons.supplement}
            gridColumn={!isReference ? "-3" : "-1"}
            dialog={<B010011 {...getSupplementProps()} />}
            dialogAction="close"
            handleSubmit={(data: any) => {
              methods.setValue("nonyuNm", data.nonyuNm);
              methods.setValue("nonyuPostCd", data.nonyuPostCd);
              methods.setValue("nonyuAddress1", data.nonyuAddress1);
              methods.setValue("nonyuAddress2", data.nonyuAddress2);
              methods.setValue("nonyuTelNo", data.nonyuTelNo);
              methods.setValue("nonyuFaxNo", data.nonyuFaxNo);
            }}
            {...register(35)}
          />
          {!isReference && (
            <>
              <SNormalButton
                label={labels.buttons.update}
                onClick={() => handleOpenUpdateConfirm()}
                {...register(36)}
              />
            </>
          )}

          <SLabel required gridColumn={1}>
            受注区分
          </SLabel>
          <SCodeSelect
            disabled
            label="受注区分"
            name="juchuKbn"
            required
            options={JuchuKbn}
            gridColumn="span 2"
          />
          <SLabel>製作日</SLabel>
          <SDateField
            name="seisakuYmd"
            disabled={isReference}
            {...register(10)}
            gridColumn="span 2"
          />
          <SLabel required>伝票日付</SLabel>
          <SDateField
            label="伝票日付"
            name="denpyoYmd"
            required
            {...register(13)}
            gridColumn="span 2"
            onBlur={() => handleChangeDenpyoYmd()}
            onAccept={(date: string) => {
              handleChangeDenpyoYmd(date);
            }}
            disabled={isReference}
          />
          <STextField name="shimeD" disabled />
          <SLabel>伝票種別</SLabel>
          <SNumberField
            name="denpyoshubetsuCd"
            code
            size={3}
            dialog={<B000111 meishoKbn={meishoKbn.denpyoshubetsu} />}
            handleSubmit={(data: any) => {
              methods.setValue("denpyoshubetsuCd", data.meishoCd);
              methods.setValue("denpyoshubetsuNm", data.meishoNm1);
            }}
            {...register(18)}
            onBlur={() =>
              B000111DenpyoshubetsuNmAndTenpudenpyo(methods, navigate, setMsg)
            }
            disabled={isReference}
          />
          <STextField name="denpyoshubetsuNm" disabled />
          <SLabel>伝票区分</SLabel>
          <SNumberField
            name="denpyoKbn"
            disabled={isReference}
            code
            size={3}
            {...register(25)}
          />
          <SLabel gridColumn="1">受注No</SLabel>
          <SNumberField
            name="juchudenpyoNo"
            code
            size={10}
            disabled
            gridColumn="span 2"
          />
          <SLabel required>発送日</SLabel>
          <SDateField
            label="発送日"
            name="shukayoteiYmd"
            required
            {...register(11)}
            gridColumn="span 2"
            onBlur={() => handleChangeShukayoteiYmd()}
            onAccept={(date: string) => {
              handleChangeShukayoteiYmd(date);
            }}
            disabled={isReference}
          />
          <SLabel required>売上区分</SLabel>
          <SCodeSelect
            label="売上区分"
            name="chohaKbn"
            required
            {...register(14)}
            options={ChohaKbn}
            gridColumn="span 3"
            disabled={isReference}
          />
          <SLabel>添付伝票</SLabel>
          <SNumberField
            name="tenpudenpyoCd"
            code
            size={3}
            dialog={
              <B000111
                meishoKbn="34"
                denpyoshubetsuCd={methods.watch("denpyoshubetsuCd")}
              />
            }
            handleSubmit={(data: any) => {
              methods.setValue("tenpudenpyoCd", data.meishoCd);
              methods.setValue("tenpudenpyoNm", data.meishoNm1);
            }}
            {...register(19)}
            onBlur={() =>
              B000111TenpudenpyoNmByDenpyoshubetsu(methods, navigate, setMsg)
            }
            disabled={isReference || isTenpudenpyoCdDisabled}
          />
          <STextField name="tenpudenpyoNm" disabled />
          <SLabel>率</SLabel>
          <SNumberField
            name="ritsu"
            size={6}
            disabled={isReference}
            {...register(26)}
          />
          <SLabel required>受注日</SLabel>
          <SDateField
            label="受注日"
            required
            name="juchuYmd"
            {...register(1)}
            disabled={isReference}
            gridColumn="span 2"
          />
          <SLabel>必着日</SLabel>
          <SDateField
            name="nohinyoteiYmd"
            {...register(2)}
            disabled={isReference}
            gridColumn="span 2"
          />
          <SLabel required>発送先</SLabel>
          <SCodeSelect
            label="発送先"
            name="hasosakiCd"
            required
            {...register(15)}
            options={HasosakiCd}
            gridColumn="span 3"
            disabled={isReference}
          />
          <SLabel>分類</SLabel>
          <SNumberField
            name="bunrui"
            code
            size={4}
            disabled={isReference}
            {...register(20)}
          />
          <SLabel gridColumn="4">持参日</SLabel>
          <SDateField
            name="jisanYmd"
            {...register(12)}
            gridColumn="span 2"
            disabled={isReference}
            onBlur={() => []}
          />
          <SLabel required gridColumn="7">
            発送区分
          </SLabel>
          <SCodeSelect
            label="発送区分"
            name="hasokbnCd"
            required
            {...register(16)}
            options={HasokbnCd}
            gridColumn="span 3"
            disabled={isReference}
          />
          <SLabel>運送会社</SLabel>
          <SNumberField
            name="unsogaishaCd"
            code
            size={4}
            dialog={<B000111 meishoKbn="32" />}
            handleSubmit={(data: any) => {
              methods.setValue("unsogaishaCd", data.meishoCd);
              methods.setValue("unsogaishaNm", data.meishoNm1);
            }}
            disabled={isReference}
            {...register(21)}
            onBlur={() => B000111UnsogaishaNm(methods, navigate, setMsg)}
          />
          <STextField name="unsogaishaNm" disabled gridColumn="span 3" />
          <SLabel required gridColumn="1">
            得意先
          </SLabel>
          <SNumberField
            label="得意先コード"
            name="tokuiCd"
            code
            size={6}
            disabled={isReference}
            {...register(3)}
            onBlur={() => handleChangeTokui()}
            required
          />
          <SNumberField
            label="得意先支店コード"
            name="tokuishitenCd"
            code
            size={4}
            disabled={isReference}
            {...register(4)}
            onBlur={() => handleChangeTokui()}
            required
            dialog={<B000150 torihikishuryoYmd={torihikishuryoYmd} />}
            handleSubmit={(data: any) => {
              methods.setValue("tokuiCd", data.tokuiCd);
              methods.setValue("tokuishitenCd", data.tokuishitenCd);
              methods.setValue("tokuiNm", data.tokuiNm1);

              // 得意先関連項目設定
              B010010Tokui(methods, navigate, setMsg);
            }}
          />
          <STextField
            label="得意先名"
            name="tokuiNm"
            size={40}
            required
            gridColumn="span 3"
            disabled
            {...register(5)}
          />
          <SLabel>消費税区分</SLabel>
          <SCodeSelect
            name="zeiKbnView"
            options={ZeiKbn}
            disabled
            gridColumn="span 3"
          />
          <SLabel>受注担当部門</SLabel>
          <STextField name="bumonCd" size={6} disabled />
          <STextField name="bumonNm" disabled gridColumn="span 3" />
          <SLabel required gridColumn="1">
            納入先
          </SLabel>
          <SNumberField
            label="納入先"
            name="nonyuCd"
            code
            size={6}
            required
            disabled={isReference}
            {...register(6)}
            onBlur={() => handleChangeNonyu()}
          />
          <SNumberField
            label="納入先支店コード"
            name="nonyushitenCd"
            code
            size={4}
            required
            onBlur={() => handleChangeNonyu()}
            disabled={isReference}
            {...register(7)}
            dialog={<B000151 torihikishuryoYmd={torihikishuryoYmd} />}
            handleSubmit={(data: any) => {
              methods.setValue("nonyuCd", data.nonyuCd);
              methods.setValue("nonyushitenCd", data.nonyushitenCd);
              methods.setValue("nonyuNm", data.tokuiNm1);

              // 納品先関連項目設定
              B010010Nonyu(methods, navigate, setMsg);
            }}
          />
          <STextField
            label="納入先名"
            name="nonyuNm"
            size={40}
            required
            {...register(8)}
            disabled={!isNonyuShokuchi || isReference}
            gridColumn="span 3"
          />
          <SLabel required>アシスタント</SLabel>
          <SNumberField
            name="assistantCd"
            code
            size={7}
            required
            disabled={isReference}
            {...register(17)}
            onBlur={() => B000140AssistantNm(methods, navigate, setMsg)}
            dialog={
              <B000140
                bumonCd={methods.watch("bumonCd")}
                eigyoCd={methods.watch("eigyoCd")}
              />
            }
            handleSubmit={(data: any) => {
              methods.setValue("assistantCd", data.shainCd);
              methods.setValue("assistantNm", data.shainNm);
            }}
          />
          <STextField name="assistantNm" disabled gridColumn="span 2" />
          <SLabel required>PPがけ</SLabel>
          <SCodeSelect
            name="ppgakeKbn"
            required
            {...register(22)}
            disabled={isReference}
            options={PpgakeKbn}
          />
          <SLabel required gridColumn="14">
            値付け
          </SLabel>
          <SCodeSelect
            name="netsukeKbn"
            required
            {...register(23)}
            disabled={isReference}
            options={NetsukeKbn}
          />
          <SLabel required gridColumn="1">
            受注担当者
          </SLabel>
          <SNumberField
            label="受注担当者"
            name="shainCd"
            code
            size={7}
            required
            disabled={isReference}
            {...register(9)}
            onBlur={() => B000140Shain(methods, navigate, setMsg)}
            dialog={
              <B000140
                eigyoCd={methods.watch("eigyoCd")}
                bumonCd={methods.watch("bumonCd")}
              />
            }
            handleSubmit={(data: any) => {
              methods.setValue("shainCd", data.shainCd);
              methods.setValue("shainNm", data.shainNm);
              methods.setValue("bumonCd", data.bumonCd);
              methods.setValue("bumonNm", data.bumonNm);
              methods.setValue("eigyoCd", data.eigyoCd);
            }}
            gridColumn="span 2"
          />
          <STextField name="shainNm" disabled gridColumn="span 3" />
          <SLabel gridColumn="11">客先No.</SLabel>
          <STextField
            name="chumonNo"
            disabled={isReference}
            size={10}
            {...register(24)}
            gridColumn="span 2"
          />
          <SText gridColumn={1}>　</SText>
          <SLabel gridColumn="1">品別番号</SLabel>
          <SNumberField
            name="hinbetsuNo"
            code
            size={10}
            disabled={isReference}
            {...register(27)}
            gridColumn="span 2"
          />
          <SLabel>納品先</SLabel>
          <STextField
            name="nohinsaki"
            size={20}
            disabled={isReference}
            {...register(31)}
            gridColumn="span 2"
          />
          <SLabel>売場名</SLabel>
          <STextField
            name="uribaNm"
            size={16}
            disabled={isReference}
            {...register(33)}
            gridColumn="span 3"
          />
          <SLabel>内線</SLabel>
          <STextField
            name="naisen"
            size={13}
            disabled={isReference}
            {...register(34)}
            gridColumn="span 2"
          />
          <SLabel gridColumn="1">担当者</SLabel>
          <STextField
            name="tantosha"
            size={16}
            disabled={isReference}
            {...register(28)}
            gridColumn="span 2"
          />
          <SLabel>ラインNo.</SLabel>
          <SNumberField
            name="lineCd"
            dialog={<B000111 meishoKbn="31" />}
            handleSubmit={(data: any) => {
              methods.setValue("lineCd", data.meishoCd);
              methods.setValue("lineNm", data.meishoNm1);
            }}
            code
            size={3}
            disabled={isReference}
            {...register(32)}
            onBlur={() => B000111LineNm(methods, navigate, setMsg)}
          />
          <STextField name="lineNm" disabled gridColumn="span 2" />
          <SLabel gridColumn="11">EDI受注番号</SLabel>
          <STextField name="ediJuchuNo" disabled gridColumn="span 2" />
          <SLabel gridColumn="1">受注備考</SLabel>
          <SNumberField
            name="bikoCd"
            dialog={<B000111 meishoKbn="2" />}
            handleSubmit={(data: any) => {
              methods.setValue("bikoCd", data.meishoCd);
              methods.setValue("biko", data.meishoNm1);
              methods.setValue("bikoCdBefore", data?.meishoCd);
            }}
            code="true"
            size={3}
            disabled={isReference}
            {...register(29)}
            onBlur={() => B000111Biko(methods, navigate, setMsg)}
          />
          <STextField
            name="biko"
            size={40}
            disabled={isReference}
            {...register(30)}
            gridColumn="span 4"
          />

          <SText gridColumn="1"></SText>
          <Box display="grid" gridColumn="span 4 / 15" gridRow="span 1">
            <Box display="grid" gridTemplateColumns="8em 8em 8em">
              <SLabel>受注金額合計</SLabel>
              <SLabel>消費税</SLabel>
              <SLabel>伝票合計</SLabel>
              <SNumberField
                name="juchuKinGokei"
                size={9}
                align="right"
                disabled
              />
              <SNumberField name="zeiGokei" size={9} align="right" disabled />
              <SNumberField
                name="denpyoGokei"
                size={9}
                align="right"
                disabled
              />
            </Box>
          </Box>
        </SFrame>
      </FormProvider>
      <SFrame>
        <STable
          keyName="juchugyoNo"
          data={rows}
          columns={columns}
          totalCount={rowCount}
          tableRef={tableRef}
          width="78rem"
          height={isReference ? "25rem" : "10rem"}
          pageSize={20}
          handleDoubleClick={
            isReference ? undefined : handleDoubleClickTableRow
          }
          rowSelectable={meiMethods.watch("meiTab")}
        />
      </SFrame>
      {isReference ? (
        <></>
      ) : (
        <FormProvider {...meiMethods}>
          <SFrame>
            <SEntryTab name="meiTab" handleOk={handleChangeMeiTab}></SEntryTab>
            <SFrame
              gridTemplateColumns="8rem 10rem 4rem 10rem 8rem 9rem 9rem 9rem 9rem"
              columnGap="3px"
              rowGap="2px"
            >
              <SLabel required>内訳区分</SLabel>
              <SLabel required gridColumn="span 2">
                商品コード
              </SLabel>
              <SLabel>JANコード</SLabel>
              <SLabel>WH(外)</SLabel>
              <SLabel required>受注数</SLabel>
              <SLabel>可能数</SLabel>
              <SLabel>上代</SLabel>
              <SLabel required>掛率</SLabel>
              <SCodeSelect
                label="内訳区分"
                name="uchiwakeKbn"
                required
                {...register(37)}
                options={JuchuUchiwakeKbn}
                disabled={isMeiDisabled}
              />
              <SNumberField
                label="商品コード"
                name="shohinCd"
                code
                size={10}
                required
                {...register(38)}
                onBlur={() =>
                  B010010HandleChangeShohinCd(
                    methods,
                    meiMethods,
                    navigate,
                    setMsg
                  )
                }
                disabled={isMeiDisabled}
                dialog={<B000200 />}
                handleSubmit={(data: any) => {
                  meiMethods.setValue("shohinCd", data.shohinCd);
                  meiMethods.setValue("janCd", data.janCd);
                  meiMethods.setValue("shohinNm", data.shohinNm);
                  B010010Shohin(methods, meiMethods, navigate, setMsg);
                }}
              />
              <SInfoButton
                {...register(39)}
                label={labels.buttons.component}
                disabled={isKoseiDisabled}
                dialog={<B010012 {...getKoseiProps()} />}
                dialogAction="close"
                handleSubmit={(data: any) => {
                  setKoseiProps(data);
                }}
              />
              <STextField
                name="janCd"
                {...register(40)}
                onBlur={() =>
                  B010010HandleChangeJanCd(
                    methods,
                    meiMethods,
                    navigate,
                    setMsg
                  )
                }
                disabled={isMeiDisabled}
                dialog={<B000200 />}
                handleSubmit={(data: any) => {
                  meiMethods.setValue("shohinCd", data.shohinCd);
                  meiMethods.setValue("janCd", data.janCd);
                  meiMethods.setValue("shohinNm", data.shohinNm);
                  B010010Shohin(methods, meiMethods, navigate, setMsg);
                }}
                code
                size={13}
              />
              <Box display="grid" gridTemplateColumns="3em auto 3em">
                <SNumberField
                  name="sotosunW"
                  onBlur={() =>
                    B010010WhTanka(methods, meiMethods, navigate, setMsg)
                  }
                  {...register(44)}
                  disabled={isMeiDisabled}
                  size={4}
                />
                <SText>✕</SText>
                <SNumberField
                  name="sotosunH"
                  onBlur={() =>
                    B010010WhTanka(methods, meiMethods, navigate, setMsg)
                  }
                  {...register(45)}
                  disabled={isMeiDisabled}
                  size={4}
                />
              </Box>
              {/* 受注生産品ORセット構成品の場合、在庫照会helpを非表示にする */}
              {isMeiJuchuSeisanhin || isSetshohinKbn ? (
                <SNumberField
                  name="juchusu"
                  required
                  label="受注数"
                  onBlur={() => handleChangeJuchusu()}
                  {...register(48)}
                  disabled={isMeiDisabled}
                  size={6}
                />
              ) : (
                <SNumberField
                  name="juchusu"
                  required
                  label="受注数"
                  onBlur={() => handleChangeJuchusu()}
                  {...register(48)}
                  disabled={isMeiDisabled}
                  size={6}
                  dialog={<B000220 shohinCd={meiMethods.watch("shohinCd")} />}
                  handleSubmit={(data: any) => {
                    meiMethods.setValue("shohinCd", data.shohinCd);
                    meiMethods.setValue("janCd", data.janCd);
                    meiMethods.setValue("shohinNm", data.shohinNm);
                    meiMethods.setValue("sokoCd", data.sokoCd);
                    meiMethods.setValue("sokoNm", data.sokoNm);
                    meiMethods.setValue("kanosu", data.hikiatekanosu);
                    meiMethods.setValue(
                      "sokoshubetsuKbn",
                      data.sokoshubetsuKbn
                    );
                    // 商品関連項目設定
                    B010010ShohinZaiko(methods, meiMethods, navigate, setMsg);
                  }}
                />
              )}
              <SNumberField name="kanosu" disabled />
              <SNumberField
                name="jodaitanka"
                {...register(49)}
                onBlur={() => {
                  handleCalcJuchutankaJuchuKin();
                }}
                disabled={isMeiDisabled || isSetshohinKbn}
                size={7}
              />
              <SNumberField
                name="kakeritsu"
                required
                label="掛率"
                {...register(51)}
                onBlur={() => {
                  handleCalcJuchutankaJuchuKin();
                }}
                disabled={isMeiDisabled || isSetshohinKbn}
                size={3}
                scale={0}
              />
              <SLabel>受注生産品</SLabel>
              <SLabel gridColumn="span 3">商品名</SLabel>
              <SLabel>WH(内)</SLabel>
              <SLabel>VOL</SLabel>
              <SLabel>課税</SLabel>
              <SLabel required>下代</SLabel>
              <SLabel required>金額</SLabel>
              <SCodeSelect
                name="juchuSeisanhinKbn"
                disabled
                options={JuchuSeisanhinKbn}
              />
              <STextField
                name="shohinNm"
                {...register(41)}
                gridColumn="span 3"
                disabled={isMeiDisabled || !isShohinShokuchiKbn}
                size={40}
              />
              <Box display="grid" gridTemplateColumns="3em auto 3em">
                <SNumberField
                  name="uchisunW"
                  {...register(46)}
                  disabled={isMeiDisabled}
                  size={4}
                />
                <SText>✕</SText>
                <SNumberField
                  name="uchisunH"
                  {...register(47)}
                  disabled={isMeiDisabled}
                  size={4}
                />
              </Box>
              <STextField name="vol" disabled />
              <STextField name="kazeiKbnView" disabled />
              <SNumberField
                label="下代"
                name="juchutanka"
                required
                {...register(50)}
                disabled={isMeiDisabled || isSetshohinKbn}
                size={7}
              />
              <SNumberField
                label="金額"
                name="juchuKin"
                required
                {...register(52)}
                disabled={isMeiDisabled || isKingakuDisabled || isSetshohinKbn}
                size={9}
              />
              <SLabel gridColumn="2/4">倉庫</SLabel>
              <SLabel>相手コード</SLabel>
              <SLabel gridColumn="5/10">受注明細備考</SLabel>
              <Box
                display="grid"
                gridColumn="2/4"
                gridTemplateColumns="4em 1fr"
              >
                <STextField
                  name="sokoCd"
                  dialog={<B000190 />}
                  handleSubmit={(data: any) => {
                    meiMethods.setValue("sokoCd", data?.sokoCd);
                    meiMethods.setValue("sokoNm", data?.sokoNm);
                    meiMethods.setValue(
                      "sokoshubetsuKbn",
                      data?.sokoshubetsuKbn
                    );
                    // 引当可能数取得処理
                    B010010Kanosu(meiMethods, navigate, setMsg);
                  }}
                  {...register(42)}
                  disabled={
                    isMeiDisabled || isSetshohinKbn || isMeiJuchuSeisanhin
                  }
                  onBlur={() => handleChangeSokoCd()}
                  size={3}
                />
                <STextField name="sokoNm" disabled gridColumn="2/3" />
              </Box>
              <STextField
                name="aiteCd"
                {...register(43)}
                disabled={isMeiDisabled}
                size={20}
              />
              <Box
                display="grid"
                gridColumn="5/10"
                gridTemplateColumns="3em 1fr"
              >
                <SNumberField
                  code
                  name="meisaibikoCd"
                  dialog={<B000111 meishoKbn="7" />}
                  handleSubmit={(data: any) => {
                    meiMethods.setValue("meisaibikoCd", data.meishoCd);
                    meiMethods.setValue("meisaibikoCdBefore", data?.meishoCd);
                    meiMethods.setValue("meisaibiko", data.meishoNm1);
                  }}
                  {...register(53)}
                  disabled={isMeiDisabled}
                  onBlur={() => B000111Meisaibiko(meiMethods, navigate, setMsg)}
                  size={3}
                />
                <STextField
                  name="meisaibiko"
                  {...register(54)}
                  disabled={isMeiDisabled}
                  size={30}
                />
              </Box>
              {!meiMethods.watch("meiTab") && (
                <SCancelButton
                  label={labels.buttons.deleteDetail}
                  gridRow="7"
                  gridColumn="1"
                  onClick={handleClickDeleteMeiButton}
                />
              )}
              {meiMethods.watch("meiTab") ? (
                <SNormalButton
                  label={labels.buttons.createDetail}
                  {...register(55)}
                  gridRow="7"
                  gridColumn="9"
                  align="right"
                  onClick={handleClickCreateMeiButton}
                />
              ) : (
                <SNormalButton
                  label={labels.buttons.updateDetail}
                  {...register(55)}
                  gridRow="7"
                  gridColumn="9"
                  align="right"
                  onClick={handleClickUpdateMeiButton}
                />
              )}
            </SFrame>
          </SFrame>
          <SConfirmDialogAction
            msg={labels.dialog.updateCheck}
            onOk={handleClickUpdateButton}
            onCancel={handleCancelUpdateConfirm}
            isOpen={openUpdateConfirm}
          />
        </FormProvider>
      )}
    </>
  );
};
